import { LoadingButton } from "@mui/lab";
import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  LinearProgress,
} from "@mui/material";
import moment from "moment";
import { useEffect } from "react";
import { useState } from "react";
import SimpleAlert from "../../../../../components/common/SimpleAlert/SimpleAlert";
import Auth from "../../../../../services/Auth/Auth";
import KodeEtikService from "../../../../../services/Integration/kode-etik/KodeEtikService";
import ProfileService from "../../../../../services/Integration/profile/ProfileService";
import { PRODI_MAHASISWA_NUMBERED } from "../../../../../utils/constants/ProdiMahasiswa.constants";

export default function KodeEtik({ mKSpesial }) {
  const user = Auth.getCurrentUser();
  const [isLoading, setIsLoading] = useState({
    getData: false,
    onSubmit: false,
  });
  const [showAlert, setShowAlert] = useState({ success: false, fail: false });
  const [mahasiswaInfo, setMahasiswaInfo] = useState({});
  const [kodeEtik, setKodeEtik] = useState({});
  const [kodeEtikChecked, setKodeEtikChecked] = useState(null);

  useEffect(() => {
    getDatas();
  }, []);

  const getDatas = async () => {
    setIsLoading({ ...isLoading, getData: true });
    await getMahasiswaData();
    setIsLoading({ ...isLoading, getData: false });
  };

  const getMahasiswaData = async () => {
    await ProfileService.getMahasiswaInfo().then((response) => {
      if (response.status === 200) {
        setMahasiswaInfo(response.data);
        getKodeEtik(response.data.id_mahasiswa);
      } else {
        console.log("Error fetching student info.");
      }
    });
  };

  const getKodeEtik = async (mahasiswaId) => {
    await KodeEtikService.getKodeEtikByMKSesialAndMahasiswaId(
      mKSpesial.id,
      mahasiswaId || user.id
    )
      .then((response) => {
        if (response.status !== 200) {
          console.log("Error fetching Kode Etik Status");
          return;
        }
        const data = response.data;
        if (data.length === 0) {
          console.log("Kode Etik not found.");
          return;
        }
        setKodeEtik(data[0]);
        if (data[0].is_agree !== null) {
          setKodeEtikChecked(data[0].is_agree);
        }
      })
      .catch((error) => console.log(error));
  };

  const handleSubmit = async () => {
    setIsLoading({ ...isLoading, onSubmit: true });
    if (!kodeEtikChecked) {
      setIsLoading({ ...isLoading, onSubmit: false });
      return;
    }
    await KodeEtikService.putKodeEtik(mKSpesial.id, kodeEtikChecked)
      .then((response) => {
        if (response.status === 200) {
          setShowAlert({ ...showAlert, success: true });
        } else {
          setShowAlert({ ...showAlert, fail: true });
        }
      })
      .catch((error) => console.log(error));
    setIsLoading({ ...isLoading, onSubmit: false });
  };

  return (
    <>
      {!isLoading.getData ? (
        <div className="flex flex-col gap-2">
          <div className="text-lg font-bold">Kode Etik</div>
          <div>
            <p>Bersama dengan pernyataan ini, saya:</p>
          </div>
          <div className="flex flex-col">
            <div className="flex flex-row gap-2">
              <div className="flex-none basis-1/4">Nama / NPM / Prodi</div>
              <div>:</div>
              <div>
                {mahasiswaInfo && (
                  <span>
                    {mahasiswaInfo.nama_mahasiswa} / {mahasiswaInfo.npm} /{" "}
                    {PRODI_MAHASISWA_NUMBERED[mahasiswaInfo.prodi]}
                  </span>
                )}
              </div>
            </div>
            <div className="flex flex-row gap-2">
              <div className="flex-none basis-1/4">Judul Karya</div>
              <div>:</div>
              <div>{mKSpesial && (mKSpesial.judul ?? "")}</div>
            </div>
          </div>
          <div>
            <p className="text-base text-justify">
              Menyatakan akan menjalani Sidang{" "}
              <b>
                {mKSpesial
                  ? mKSpesial.jenis_sidang ?? "Jenis Sidang"
                  : "Jenis Sidang"}
              </b>{" "}
              dengan JUJUR DAN PENUH INTEGRITAS. Saya akan menjawab pertanyaan
              dari penguji dan pembimbing sesuai kemampuan saya sendiri tanpa
              dibantu oleh siapapun. Jika di kemudian hari saya diketahui
              melanggar ketentuan, maka saya bersedia diproses sesuai ketentuan
              yang berlaku (SK Dekan 103a Tahun 2020) dengan sanksi maksimal
              nilai akhir E.
            </p>
          </div>
          <div>
            <FormControlLabel
              control={
                <Checkbox
                  checked={kodeEtikChecked ?? false}
                  disabled={
                    kodeEtik.is_agree != null && kodeEtik.is_agree === true
                  }
                  onChange={(e) => {
                    setKodeEtikChecked(e.target.checked);
                  }}
                />
              }
              label="Ya, saya setuju."
            />
          </div>
          {kodeEtik.is_agree === true && kodeEtik.timestamp && (
            <div>
              Disetujui pada{" "}
              {moment(kodeEtik.timestamp).format("D MMM YYYY, HH:mm [GMT]Z")}
            </div>
          )}
          <div>
            <LoadingButton
              loading={isLoading.onSubmit}
              disabled={kodeEtik.is_agree}
              variant="contained"
              onClick={() => handleSubmit()}
            >
              Simpan
            </LoadingButton>
          </div>
          <SimpleAlert
            open={showAlert.success}
            onClose={() => {}}
            dialogTitle={"Berhasil!"}
            dialogMessage={"Kode etik berhasil disimpan di SISIDANG!"}
            dialogActions={
              <>
                <Button
                  onClick={() => {
                    getDatas();
                    setShowAlert({ ...showAlert, success: false });
                  }}
                >
                  Ok
                </Button>
              </>
            }
          />
          <SimpleAlert
            open={showAlert.fail}
            onClose={() => {}}
            dialogTitle={"Gagal!"}
            dialogMessage={"Kode etik gagal disimpan di SISIDANG!"}
            dialogActions={
              <>
                <Button
                  onClick={() => {
                    setShowAlert({ ...showAlert, fail: false });
                  }}
                >
                  Ok
                </Button>
              </>
            }
          />
        </div>
      ) : (
        <Box>
          <LinearProgress />
        </Box>
      )}
    </>
  );
}
